import React, { useState, useMemo } from 'react';
import { useForm } from "react-hook-form";
import { TextField } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { yupResolver } from "@hookform/resolvers/yup";
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

import { TypographyNomal, TypographyNomalBold } from '../style/typography';
import { BoxSpaceWrap } from '../style/box';
import { formatteDateText } from "../func/util";
import { validationSchemaEarthquake } from '../func/validation_check';
import { CustomTextFieldElementEarthquake } from '../components/CustomTextFieldElement';

export default function BasicEarthquakeInfo({ earthquake, setEarthquake, isReadOnly }) {
    const [validationError, setValidationError] = useState(null);

    const { control, formState: { errors } } = useForm({
        defaultValues: { earthquakes: { max_intensity: earthquake.max_intensity, epicenter: earthquake.epicenter }},
        resolver: yupResolver(validationSchemaEarthquake),
        mode: "onBlur"
    });

    const errorMessage = useMemo(() => {
        switch (validationError) {
            case 'invalidDate':
                return '有効な日時形式で入力してください。';
            default:
                return '';
        }
    }, [validationError]);

    // 入力フィールド変更
    const handleChange = (field) => (event) => {
        setEarthquake({ ...earthquake, [field]: event.target.value });
    };

    // 地震発生日時変更
    const handleDateChange = (newDate) => {
        // JSTでISO文字列化して保存
        const updatedDate = newDate ? dayjs(newDate).tz('Asia/Tokyo').format() : null;
        setEarthquake({ ...earthquake, occured_at: updatedDate });
    };

    const handleDateError = (newError) => {
        setValidationError(newError);
    };

    return (
        <>
            <Grid container spacing={5} columns={12} p={2}>
                <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                    <BoxSpaceWrap>
                        <TypographyNomalBold>地震発生日時</TypographyNomalBold>
                        {isReadOnly
                            ? dayjs(earthquake.occured_at).format("YYYY/MM/DD HH:mm")
                            : <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                    label="地震発生日時"
                                    value={ earthquake.occured_at ? dayjs(earthquake.occured_at) : null }
                                    ampm={false}
                                    onChange={handleDateChange}
                                    onError={handleDateError}
                                    format={"YYYY/MM/DD HH:mm"}
                                    slotProps={{
                                        textField: {
                                            error: !!validationError,
                                            helperText: errorMessage,
                                            fullWidth: true,
                                            margin: "dense",
                                        },
                                    }}
                                />
                              </LocalizationProvider>
                        }
                    </BoxSpaceWrap>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                    <BoxSpaceWrap>
                        <TypographyNomalBold>最大震度</TypographyNomalBold>
                        {isReadOnly ? earthquake.max_intensity :
                            <CustomTextFieldElementEarthquake
                                name={"max_intensity"}
                                control={control}
                                label={"最大震度"}
                                onChange={handleChange("max_intensity")}
                                errors={errors}
                            />
                        }
                    </BoxSpaceWrap>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                    <BoxSpaceWrap>
                        <TypographyNomalBold>震源地</TypographyNomalBold>
                        {isReadOnly ? earthquake.epicenter :
                            <CustomTextFieldElementEarthquake
                                name={"epicenter"}
                                control={control}
                                label={"震源地"}
                                onChange={handleChange("epicenter")}
                                errors={errors}
                            />
                        }
                    </BoxSpaceWrap>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                    <BoxSpaceWrap>
                        <TypographyNomalBold>第1報報告日時</TypographyNomalBold>
                        <TypographyNomal sx={{ mt: 1 }}>
                            {earthquake.initial_report_sent_at
                                ? formatteDateText(earthquake.initial_report_sent_at)
                                : "-"}
                        </TypographyNomal>
                    </BoxSpaceWrap>
                </Grid>
            </Grid>
        </>
    );
}